import { InjectionToken } from '@angular/core';
import { Client } from './filestack.model';

export const FILESTACK_CLIENT: InjectionToken<Client> = new InjectionToken<Client>('Filestack client');
